import type { EventAttributes } from '@/types/events'

/** What a public-page link needs: the event id, plus its shortcode once the event has loaded. */
export interface PublicEventLinkTarget {
  id: string
  attributes?: Pick<EventAttributes, 'shortcode'> | null
}

/**
 * The in-app path to an event's public page, the watch screen: `/e/<shortcode>`, or `/e/<id>` until the shortcode has
 * loaded (the page finds the event by either and settles on the shortcode).
 */
export function publicEventPath(event: PublicEventLinkTarget): string {
  const shortcode = event.attributes?.shortcode?.trim()
  return `/e/${encodeURIComponent(shortcode || event.id)}`
}

/** `publicEventPath` as an absolute URL, for links people copy or share. */
export function publicEventUrl(event: PublicEventLinkTarget, origin: string = window.location.origin): string {
  return `${origin}${publicEventPath(event)}`
}
